import type { CSSProperties } from "react";

interface Props {
  /** "dark" - dark mark for light bg. "light" - white mark for dark bg. */
  variant?: "dark" | "light";
  height?: number;
  label?: string;
  style?: CSSProperties;
  /** URL to a logo image. Falls back to the bundled Nenda logos. */
  src?: string;
}

const DEFAULT_DARK = "/foyer-assets/nenda-logo.png";
const DEFAULT_LIGHT = "/foyer-assets/nenda-logo-white.png";

/**
 * Hotel logo. Schemes render this at the top of every screen. The
 * caller picks the variant based on its own background (Atelier +
 * Mosaic use dark, Spectrum uses light). One swap to rebrand.
 */
export function Logo({
  variant = "dark",
  height = 22,
  label = "Hotel logo",
  src,
  style,
}: Props) {
  const resolved = src ?? (variant === "light" ? DEFAULT_LIGHT : DEFAULT_DARK);
  return (
    <div
      role="img"
      aria-label={label}
      style={{
        height,
        width: height * 3.74, // matches the 512:137 aspect ratio of the bundled mark
        backgroundImage: `url(${resolved})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "left center",
        ...style,
      }}
    />
  );
}
